var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.875 3.42416V3.41941L15.4304 5.01184L19 3.67353L9.5 0.111032L0 3.67353L9.5 7.23603L13.0554 5.90247L9.5 4.43709V4.43353L11.875 3.42416Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.86103V15.5485L8.90625 18.889V8.20147L0 4.86103ZM4.75 15.5877L2.375 14.6971V13.43L4.75 14.3207V15.5877Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4375 6.19697V9.17166L13.0625 10.0623V7.08759L10.0938 8.20147V18.889L19 15.5485V4.86103L15.4375 6.19697Z",
    fill: "#111F3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/orderIcon.0cfe012669f0a6cab366821f9940f8a6.svg";
export { ForwardRef as ReactComponent };